var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"claims-compare"},[_vm._t("tip"),_vm._v(" "),_c('pre',{ref:"compareResult"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-box center"},[_c('Loading')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }